<template>
  <div class="page-body ">
    <!--<PageTitle title="CANTEEN HEADCOUNT - LIVE KITCHEN SCREEN" />-->
 
 

    <div class="dashboard-header mt-4">

       
        <div class="title-section">
            <h1>CANTEEN HEADCOUNT - LIVE KITCHEN SCREEN</h1>
            <small>
                Real-time Headcount for OT / Sunday / Holiday
            </small>
        </div>

        <div class="live-clock">
            <span class="live-dot"></span>
            LIVE
            <br>
            {{ currentTime }}
        </div>

    </div>

    <!-- Top Cards -->

    <div class="row g-3 mb-3">

        <div class="col-lg-2">
            <div class="stat-card">
                <h6>Grand Total</h6>
                <h1>{{ dashboard.grand_total }}</h1>
            </div>
        </div>

        <!--<div class="col-lg-2">-->
        <!--    <div class="stat-card">-->
        <!--        <h6>OT Total</h6>-->
        <!--        <h1 class="text-danger">-->
        <!--            {{ dashboard.ot_total }}-->
        <!--        </h1>-->
        <!--    </div>-->
        <!--</div>-->

        <div class="col-lg-3">
            <div class="stat-card">
                <h6>Headcount Date</h6>
                <h2>{{ today }}</h2>
                <span @click="getDashboard(true)" class="badge bg-danger text-white p-1">Next Date</span>
            </div>
        </div>

        <div class="col-lg-3">
            <div class="stat-card">
                <h6>Departments</h6>
                <h1>{{ dashboard.departments }}</h1>
            </div>
        </div>

        <div class="col-lg-4">
            <div class="stat-card">
                <h6>Last Updated</h6>
                <h3>
                    {{ dashboard.last_updated }}
                </h3>
            </div>
        </div>

    </div>

    <div class="row">

        <!-- Main Table -->

        <div class="col-lg-9">

            <div class="card">

                <div class="card-header">
                    Department Wise Headcount Summary
                </div>

                <div class="card-body p-0 table-responsive">

                    <table class="table table-bordered mb-0">

                        <thead>

                        <tr>
                            <th>Department</th>
                            <th>1st</th>
                            <th>General</th>
                            <th>2nd</th>
                            <th>3rd</th>
                            <th>OT</th>
                            <th>Total</th>
                            <!--<th>OT</th>-->
                            <th>Updated By</th>
                        </tr>

                        </thead>

                        <tbody>

                        <tr
                            v-for="item in dashboard.summary"
                            :key="item.department"
                        >
                            <td>{{ item.deptname }}</td>

                            <td>{{ item.shift1 }}</td>
                            <td>{{ item.general_shift }}</td>
                            <td>{{ item.shift2 }}</td>
                            <td>{{ item.shift3 }}</td>
                            <td>{{ item.ot }}</td>

                            <td class="fw-bold text-primary">
                                {{ item.total }}
                            </td>

                            <!--<td class="fw-bold text-danger">-->
                            <!--    {{ item.ot }}-->
                            <!--</td>-->

                            <td>
                                {{ item.prepared_by }}
                            </td>

                        </tr>

                        </tbody>

                    </table>

                </div>

            </div>

            <!-- Logs -->

            <div class="card mt-3">

                <div class="card-header">
                    Recent Updates
                </div>

                <div class="card-body">

                    <div
                        class="log-card"
                        v-for="log in dashboard.logs"
                        :key="log.id"
                    >
                       <div v-html="log.message"></div>  
                    </div>

                </div>

            </div>

        </div>

        <!-- Right Panel -->

        <div class="col-lg-3">

            <div class="card">

                <div class="card-header">
                    Headcount Breakup
                </div>

                <div class="card-body p-0">

                    <table class="table">

                        <tr
                            v-for="item in dashboard.breakup"
                            :key="item.category"
                        >
                            <td>{{ item.category }}</td>
                            <td class="fw-bold text-end">
                                {{ item.total }}
                            </td>
                        </tr>

                    </table>

                </div>

            </div>


        </div>

    </div>

</div>
</template>

<script>

import axios from '@/plugins/axios';

export default {

    name:'KitchenDashboard',

    data(){

        return{

            dashboard:{
                summary:[],
                breakup:[],
                logs:[]
            },

            currentTime:'',
            interval:null,
            today:null
        }
    },

    mounted(){

        this.getDashboard();

        this.interval =
            setInterval(this.getDashboard,30000);

        setInterval(()=>{

            this.currentTime =
                new Date().toLocaleTimeString();

        },1000);

    },

    beforeUnmount(){

        clearInterval(this.interval);

    },

   

    methods:{

        getDashboard(isNext=false){

            axios.post('getKitchenDashboard',{isNext:isNext,today:this.today})
            .then((response)=>{

                this.dashboard =response.data;
                 this.today=response.data.headcount_date;

            });

        }

    }

}
</script>

<style scoped>

.kitchen-dashboard{
    background:#f5f7fb;
    min-height:100vh;
}

.dashboard-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom:20px;
}

.title-section{
    text-align:center;
}

.title-section h1{
    font-size:36px;
    font-weight:700;
    color:#001b5f;
}

.live-dot{
    width:12px;
    height:12px;
    background:green;
    display:inline-block;
    border-radius:50%;
}

.stat-card{
    background:white;
    border-radius:10px;
    padding:20px;
    text-align:center;
    box-shadow:0 2px 5px rgba(0,0,0,.08);
}

.card-header{
    background:#002a7f;
    color:white;
    font-weight:600;
}

thead{
    background:#002a7f;
    color:white;
}

.table td,
.table th{
    text-align:center;
    vertical-align:middle;
}

.log-card{
    border:1px solid #eee;
    padding:10px;
    margin-bottom:10px;
}
</style>